import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import ClearButton from './clearButton';
import Generator from './generator';
import LimitControl from './limitControl';

const transportTypes = [
  {'text': 'Aereo', 'value': 'A'},
  {'text': 'Marítimo', 'value': 'M'},
];

const orderTypes = [
  {'text': 'Normal', 'value': '00'},
  {'text': 'INEN', 'value': '01'},
];

class HeadSection extends Component {
  constructor(props) {
    super(props);
    this.handleParameterChange = this.handleParameterChange.bind(this);
  }

  componentDidMount() {
    this.props.loadProviders({'withOrigin': true});
  }

  handleParameterChange(event, data) {
    this.props.changeProviderManualOrderParameter(data.name, data.value);
  }

  formatProviders(providers = []) {
    return providers.map((provider) => ({'text': provider.name, 'value': provider.code}));
  }

  render() {
    const {loading, loadingProviders, providers, provider, transport, orderType} = this.props;

    return (
      <Card raised fluid className='manual-orders-header'>
        <Grid raised fluid>
          <Grid.Row>
            <Grid.Column width='8' textAlign='left'><h2>Pedidos Manuales</h2></Grid.Column>
            <Grid.Column width='8' textAlign='right'>
              <LimitControl />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width='3' textAlign='left'>
              <label><strong>Proveedor</strong></label>
              <Dropdown selection fluid
                name='provider'
                options={this.formatProviders(providers)}
                disabled={loadingProviders || loading || !!provider}
                loading={loadingProviders}
                value={provider}
                onChange={this.handleParameterChange}
              />
            </Grid.Column>
            <Grid.Column width='3' textAlign='left'>
              <label><strong>Transporte</strong></label>
              <Dropdown selection fluid
                name='transport'
                disabled={loadingProviders || loading || !!transport}
                options={transportTypes}
                value={transport}
                onChange={this.handleParameterChange}
              />
            </Grid.Column>
            <Grid.Column width='3' textAlign='left'>
              <label><strong>Tipo de repuesto</strong></label>
              <Dropdown selection fluid
                name='orderType'
                disabled={loadingProviders || loading || !!orderType}
                options={orderTypes}
                value={orderType}
                onChange={this.handleParameterChange}
              />
            </Grid.Column>
            <Grid.Column width='7' textAlign='right' verticalAlign='bottom'>
              <ClearButton />
              <Generator />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingProviders': state.provider.loading,
    'loading': state.providerManualOrder.loading,
    'providers': state.provider.list,
    'provider': state.providerManualOrder.provider,
    'transport': state.providerManualOrder.transport,
    'orderType': state.providerManualOrder.orderType,
  };
};

const {
  loadProviders,
  changeProviderManualOrderParameter,
} = Actions;

export default connect(mapStateToProps, {
  loadProviders,
  changeProviderManualOrderParameter,
})(HeadSection);
